import React, { useEffect, useState } from 'react';
import SpeakersPreviewModuleHead from '../../components/SpeakersPreviewModuleHead/index';
import './style.scss';

interface UsersPreviewModuleProps {
  content: {
    title: string;
    titleAlign: 'start' | 'end' | 'left' | 'right' | 'center' | 'justify' | 'match-parent';
    api: string;
    vars: object;
    returnedListName: Function;
    getData: Function;
  };
  getData: Function;
  openPopover: Function;
  getImage: Function;
}

const UsersPreviewModule: React.FC<UsersPreviewModuleProps> = ({
  content: { title, titleAlign, api, vars, returnedListName },
  getData,
  openPopover,
  getImage,
}) => {
  const [usersList, setUsersList] = useState([]);
  const align = titleAlign ? titleAlign : null;
  const endPoint = api
    ? //@ts-ignore
      CrowdHub_App.CONFIG.BASE_URL + api
    : //@ts-ignore
      CrowdHub_App.CONFIG.BASE_URL + 'custom_api/api_user_getSuggestedFollowers.php';

  useEffect(() => {
    let users = getData(
      endPoint,
      vars,
      data => {
        if (data.success === 'true' && data.users) {
          setUsersList(data.users);
        }
      },
      () => {
        console.warn('ERROR retrieving user list');
      },
    );
  }, []);

  return (
    <div className="users_preview_module ui_relative element">
      <div className="users_preview_title_wrapper">
        <div style={{ textAlign: align }} className="users_preview_title title primary-font-family">
          {title}
        </div>
      </div>
      <div style={{ textAlign: align }} className="user_heads_container">
        {usersList.map(user => {
          //@ts-ignore
          const newUser = new CustomUser();
          newUser.initialize(user);
          return (
            <SpeakersPreviewModuleHead key={newUser.Id} openPopover={openPopover} getImage={getImage} user={newUser} />
          );
        })}
      </div>
    </div>
  );
};

export default UsersPreviewModule;
